import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    title: {
        fontSize: 22,
        color: '#000006',
        fontFamily: 'Montserrat',
        marginBottom: 35,
        fontWeight: '900',
    },
    subTitle: {
        fontSize: 14,
        color: '#000006',
        fontWeight: '600',
        fontFamily: 'Montserrat',
        marginBottom: 6,
    },
    buttonsContainer: {
        flexDirection: 'row',
        justifyContent:'space-around',
        marginTop: 20,
    },
});
